<template>
  <el-container>
    <el-main>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-result class="flush-box" title="清除缓存" subTitle="清除系统的所有缓存">
            <template slot="extra">
              <el-button type="primary" size="medium" @click="clear">立即清除</el-button>
            </template>
          </el-result>
        </el-col>
        <el-col :span="8">
          <el-result class="flush-box" title="清除日志" subTitle="清除系统的所有日志">
            <template slot="extra">
              <el-button type="primary" size="medium" @click="clear">立即清除</el-button>
            </template>
          </el-result>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Dashboard',
  data () {
    return {
      records: [
        {
          name: '小A',
          role: '小区管理员',
          mobile: '1556666888',
          username: 'demo1',
          created_at: '2025-03-01',
          status: 1
        },
        {
          name: '小B',
          role: '小区管理员',
          mobile: '1557777888',
          username: 'demo2',
          created_at: '2025-01-01',
          status: 0
        }
      ]
    }
  },
  mounted () {
    console.log(this.records)
  },
  methods: {
    clear () {
      this.$confirm(`确定清除吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '清除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消'
        })
      })
    }
  }
}
</script>

<style scoped>
.el-aside {
  border-right: 1px solid #ddd;
}
.list-group li {
  cursor: pointer;
  padding: 0 10px;
}
.list-group li:hover, .list-group li.active {
  background-color: #ecf5ff;
}
.flush-box {
  border: #ddd 1px solid;
}
.flush-box :deep(.el-result__icon) {
  display: none;
}
</style>
